import { QuestGridCards } from './styles';
import React, { useEffect, useState } from 'react';
import QuestCard from '../../UI/QuestCard';
import { useQuests } from '../../../hooks/quests';
import { QuestByCompanySlug } from '../../../models/quests';
import { Title } from '../../UI';
import { Divisor } from '../../../styles/pages/quests/styles';
import { getExtensionVersion, isAppV2 } from '../../../services/versionManager';
import CoinIcon from '../../../assets/MobileMenu/coin.svg';
import { ItemsScrollDefaultHeader, GridItems } from '../../../components/ItemsScroll';
import Skeleton from '../../Skeleton';
import theme from '../../../styles/theme';
import { t } from 'i18next';

interface CompanyQuestsProps extends LoadingProps {
  company_slug: string;
  device_id?: string;
}

const CompanyQuests: React.FC<CompanyQuestsProps> = ({ company_slug, device_id }) => {
  const { getQuestsByCompanySlug } = useQuests();

  const [questsByCompanySlugByPeriodType, setQuestsByCompanySlugByPeriodType] = useState<{ [key: string]: QuestByCompanySlug[] }>({});
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [extensionVersion, setExtensionVersion] = useState(null);

  useEffect(() => {
    getExtensionVersion().then((value) => {
      setExtensionVersion(value);
    });
  }, []);

  useEffect(() => {

    if (!company_slug) {
      return;
    }

    async function getInitialData() {
      try {
        let quests = await getQuestsByCompanySlug(company_slug, null, null, null, null, device_id);

        // Only link quests
        quests = quests.filter((quest) => quest.quest_link !== null);

        // Sort by not completed and with budget first
        quests = quests.sort((quest1, quest2) => {

          let completedQuest1 = quest1.quest_reward !== null;
          let completedQuest2 = quest2.quest_reward !== null;

          let isBudgetQuest1 = quest1.is_budget === true;
          let isBudgetQuest2 = quest2.is_budget === true;

          // Budget sort. Quests without budget goes at the end

          if (isBudgetQuest1 && !isBudgetQuest2) {
            return -1;
          }

          if (!isBudgetQuest1 && isBudgetQuest2) {
            return 1;
          }

          //

          // Completed quests sort. These go in the middle

          if (completedQuest1 && !completedQuest2) {
            return 1;
          }

          if (!completedQuest1 && completedQuest2) {
            return -1;
          }

          //

          return 0;
        });

        // Group by period type
        const questsByPeriodType = quests.reduce((acc, quest) => {
          if (!acc[quest.period_type]) {
            acc[quest.period_type] = [];
          }

          acc[quest.period_type].push(quest);

          return acc;
        }, {});

        setQuestsByCompanySlugByPeriodType(questsByPeriodType);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    }

    getInitialData();
  }, [company_slug]);

  function getQuestsByPeriod(period_type: string, period_name: string, isFirst?: boolean) {

    let quests = questsByCompanySlugByPeriodType[period_type];

    if (quests && quests.length > 0) {
      return (
        company_slug == 'read-to-earn' ?
          <div style={{width: '100%'}}>
            <GridItems
              header={() => <></>}
              gap={15}
              gridMinPx={100}
            >
              { isLoading ?
                Array.from(Array(10)).map((_, idx) => {
                  return <div
                    key={idx}
                    style={{
                      minHeight: 300,
                      height: 300,
                      width: '100%',
                    }}
                  >
                    <Skeleton style={{
                      height: '100%',
                      width: '100%',
                      borderRadius: '15px',
                    }}></Skeleton>
                  </div>

                }) :

                quests.map((readToEarn, idx) => {
                  return <div
                    key={idx}
                    style={{
                      minHeight: 300,
                      height: 300,
                      width: '100%',
                      borderRadius: '15px',
                      border: 'solid black 2px',
                      padding: 10,
                    }}
                  ><button
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '100%',
                      height: '100%',
                    }}
                    onClick={() => {
                      if(isAppV2()) {
                        window.location.href = '/open-in-app/coingoback-quest-navigation/quests/'+readToEarn.id;
                      } else if(extensionVersion !== null) {
                        if(extensionVersion === '2.3.2') {
                          window.open(readToEarn.quest_link.initial_url, '_blank');
                        } else {
                          window.open('https://bff.prod.coingoback.com/enable-quest?quest_id='+readToEarn.id, '_blank');
                        }
                      }
                    }}
                  >
                      <div style={{
                        minHeight: 150,
                        borderRadius: '15px',
                        border: 'solid black 2px',
                        backgroundImage: "url('" + readToEarn.image + "')",
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center center',
                        width: '100%'
                      }}></div>
                      <div style={{ height: '100%',  width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
                        <h3 style={{marginTop: 20, textAlign: 'left', color: 'black'}}>{ readToEarn.title.substring(0, 69) + (readToEarn.title.length > 70 ? '...' : '') }</h3>
                        <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <div style={{ border: 'solid black 1px', borderRadius: '8px', padding: '5px 10px', display: 'flex', alignItems: 'center', backgroundColor: readToEarn.quest_reward ? 'white': theme.colors.primary.main }}>
                            {readToEarn.reward_currency === 'BTC' ?
                            <CoinIcon style={{ filter: 'brightness(0)', marginRight: 3, width: 12, height: 12 }}/>
                            : <></>}
                            <span style={{ color: 'black' }}>{ readToEarn.reward_amount_formatted }</span>
                          </div>
                        </div>
                      </div>
                    </button>
                  </div>
                })
              }
            </GridItems>
          </div>
        :
          <>
            {isFirst ? (null) : (<Divisor style={{ marginBottom: 16, marginTop: 16 }} />)}
            <Title>{period_name}</Title>
            <div style={{ padding: 8 }}></div>
            <QuestGridCards>
              {isLoading
                ? [...Array(20)].map((_, idx) => (
                  <QuestCard.CardLoading key={idx} />
                ))
                : quests.map((questByCompanySlug, idx) => {

                  let enabled = questByCompanySlug.is_budget == true && questByCompanySlug.quest_reward == null;

                  return <QuestCard.SingleQuest
                    key={idx}
                    title={questByCompanySlug.title}
                    description={questByCompanySlug.description}
                    reward_amount_formatted={questByCompanySlug.reward_amount_formatted}
                    period_type={questByCompanySlug.period_type}
                    is_budget={questByCompanySlug.is_budget && questByCompanySlug.quest_link?.initial_url ? true : false}
                    quest_completed={questByCompanySlug.quest_reward ? true : false}
                    time_seconds={questByCompanySlug.quest_link.time_seconds}
                    notClickable={!enabled}
                    onClick={() => {
                      if(isAppV2()) {
                        window.location.href = '/open-in-app/coingoback-quest-navigation/quests/'+questByCompanySlug.id;
                      } else if(extensionVersion !== null) {
                        if(extensionVersion === '2.3.2') {
                          window.open(questByCompanySlug.quest_link.initial_url, '_blank');
                        } else {
                          window.open('https://bff.prod.coingoback.com/enable-quest?quest_id='+questByCompanySlug.id, '_blank');
                        }
                      }
                    }}
                  />
                }
                )}
            </QuestGridCards>
          </>
      );
    }

    return (null);
  }

  function getQuests() {
    let sectionTranslations = {
      'DAILY': t('components.quests.daily'),
      'WEEKLY': t('components.quests.weekly'),
      'MONTHLY': t('components.quests.monthly'),
      'UNIQUE': t('components.quests.unique'),
    };

    let questSections = [];

    for (const [periodType, periodName] of Object.entries(sectionTranslations)) {

      if (!questsByCompanySlugByPeriodType[periodType]) {
        continue;
      }

      let isFirst = false;

      if (questSections.length === 0) {
        isFirst = true;
      }

      questSections.push(getQuestsByPeriod(periodType, periodName, isFirst));
    }

    return questSections;
  }

  return (
    <>
      {getQuests()}
    </>
  );
};

export default CompanyQuests;
